export default __webpack_public_path__ + "static/media/580.c1522ef9.jpg";